import React, { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetOldRequestNumberDropdownQuery } from '../../../api/endpoints/teamProductivityMeasurement';
import { useLanguage } from '../../../contexts/LanguageContext';

const OldRequestFilterDropdown = ({ value, onChange, className = '' }) => {
    const { th } = useLanguage();
    const [searchText, setSearchText] = useState('');

    const { data: list = [], isLoading } = useGetOldRequestNumberDropdownQuery({
        rowCount: 100,
        searchText: searchText || undefined
    });

    const options = list.map((item) => ({
        label: String(item.requestNumber),
        value: String(item.requestNumber)
    }));

    return (
        <Dropdown
            value={value || null}
            options={options}
            onChange={(e) => onChange(e.value)}
            onFilter={(e) => setSearchText(e.filter)}
            optionLabel="label"
            optionValue="value"
            className={className}
            placeholder={th('common.search')}
            loading={isLoading}
            filter
            showClear
            emptyFilterMessage={th('filter.noResultsFound')}
        />
    );
};

export default OldRequestFilterDropdown;